var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPecimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 37",
    style: {
      enableBackground: "new 0 0 130 37"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D91A32;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.9,
    className: "st0",
    width: 37.9,
    height: 35.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4.4,20.6 4.4,20.6 4.4,20.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,20.6L33.5,20.6c-3.1-3.5-5.5-7.7-7-12.1l0,0c-1.1-3.2-4.1-5.4-7.6-5.4c-3.4,0-6.5,2.2-7.6,5.4v0l0,0 c-1.5,4.5-3.9,8.6-7,12.1l0,0l0,0c0,0,0,0,0,0l0,0c-1.3,1.5-2,3.3-2,5.3c0,4.4,3.6,8,8,8c0.5,0,1-0.1,1.6-0.2l0,0 c2.3-0.5,4.6-0.7,7-0.7c2.3,0,4.7,0.2,7,0.7l0,0c0.5,0.1,1,0.2,1.6,0.2c4.4,0,8-3.6,8-8C35.5,24,34.8,22.1,33.5,20.6L33.5,20.6z  M27.5,31.5c-0.4,0-0.7,0-1.1-0.1l0,0c-2.5-0.5-5-0.7-7.5-0.7c-2.5,0-5,0.2-7.5,0.7l0,0c-0.4,0.1-0.7,0.1-1.1,0.1 c-3.1,0-5.6-2.5-5.6-5.6c0-1.4,0.5-2.7,1.4-3.7l0,0l0,0C9.5,18.4,12,14,13.6,9.3v0l0,0C14.4,7,16.6,5.5,19,5.5 c2.4,0,4.6,1.5,5.3,3.8l0,0c1.6,4.7,4.1,9.1,7.5,12.9l0,0l0,0c0.9,1,1.4,2.3,1.4,3.7C33.2,29,30.6,31.5,27.5,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,22.3c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6C22.5,23.9,20.9,22.3,19,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,18.5c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6C16.7,22.1,18.3,20.5,18.3,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,18.5c0-2-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6S26.9,20.5,26.9,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.4,22.3c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6C14,23.9,12.4,22.3,10.4,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,22.3c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6C31.1,23.9,29.5,22.3,27.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,14.7c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6C15.4,13.1,17,14.7,19,14.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130,2.3c-2.6-0.9-5.5-1.4-8.3-1.4c-10,0-17.8,8-17.8,17.9c0,9.7,7.6,17.3,17.3,17.3c2.2,0,6.8-0.4,8.8-1.4 l0-12.5c-2,1.9-3.9,2.9-6.7,2.9c-3.7,0-6.9-2.9-6.9-6.6c0-3.7,3-6.6,6.7-6.6c2.8,0,4.9,1.2,6.9,3.1L130,2.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.8,36.1 100.8,36.1 100.8,26.5 89.6,26.5 89.6,23 97.5,23 97.5,13.9 89.6,13.9 89.6,10.5  100.9,10.5 100.9,0.9 76.8,0.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,10.5h1.2c2.1,0,4.7,0.1,4.7,2.9c0,2.8-2.4,3.2-4.7,3.2h-1.3V10.5z M43,36.1h12.3V25.5h6.5 c7.1,0,11.6-4.5,11.6-11.7c0-8.7-6.1-12.9-14.3-12.9H43V36.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPecimg);
export default __webpack_public_path__ + "static/media/PECIMG.abff52f6427c0c066035c2372cb6951a.svg";
export { ForwardRef as ReactComponent };